import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'projects/customer/src/app/shared/services/http-service.service';
import { AxiosAuthenticationService } from 'projects/customer/src/app/shared/services/axios-authentication.service';

@Injectable({
    providedIn: 'root'
})
export class SuppliersService {
    constructor(public httpService: HttpService) {}

    getCountryList() {
        const path = 'v1/masters/countries';
        return this.httpService.callAuthGetMasterApi(path);
    }

    getStateList(id: any) {
        const path = 'v1/masters/states/' + id;
        return this.httpService.callAuthGetMasterApi(path);
    }

    getSupplierDetails(id: any) {
        const path = `suppliers/${id}/supplier_details`;
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    getSupplierCount() {
        const path = `suppliers/counts`;
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    updateSupplier(id: any, data) {
        const path = `suppliers/${id}/update`;
        return this.httpService.callPutApi(path, data, 'jsonApi');
    }

    activateDeactivateSupplier(id: any, state) {
        const path = `frontend/v1/suppliers/${id}/update_state`;
        return this.httpService.callPutApi(path, state);
    }

    public createSupplier(params: any) {
        const path = 'suppliers/create';
        return this.httpService.callAuthPostApi(path, params, 'jsonApi');
    }

    getSupplierTemplateFile() {
        const path = 'v1/masters/templates?type=10';
        return this.httpService.getFileAsBlob(path);
    }

    bulkUploadSuppliersData(file) {
        const path = 'suppliers/import';
        return this.httpService.callUploadFileServiceApi(path, file, 'jsonApi');
    }

    public getSupplierGrid(
        state?: any,
        searchPattern?: string,
        page?: number,
        pageSize?: number
    ) {
        const path = `suppliers/${state}/supplier?filter[search_pattern]=${searchPattern}&page[number]=${page}&page[size]=${pageSize}`;
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    public updateStateBulk(data) {
        const path = `suppliers/bulk_update_state`;
        return this.httpService.callPutApi(path, data, 'jsonApi');
    }
    getsupplierService(path) {
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }
}
